(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function speed(details) {
    var host = details.closest('product-info');
    var ms = host && parseInt(host.dataset.mpAccordionSpeed || '', 10);
    return ms || 275;
  }

  function singleOpen(details) {
    var host = details.closest('product-info');
    return !!(host && host.dataset.mpAccordionSingle === 'true');
  }

  function content(details) {
    return details.querySelector('.accordion__content');
  }

  function naturalHeight(box) {
    var inner = box.querySelector('.mp-accordion__inner');
    return (inner || box).offsetHeight;
  }

  /* Run one height transition and call `done` exactly once, when it has really
     finished (or when the safety net trips). */
  function animate(details, box, from, to, done) {
    var settled = false;

    function finish(event) {
      if (event && (event.target !== box || event.propertyName !== 'height')) return;
      if (settled) return;
      settled = true;
      box.removeEventListener('transitionend', finish);
      window.clearTimeout(timer);
      done();
    }

    box.classList.add('mp-animating');
    box.style.height = from;
    /* force a reflow so the browser has a start value to animate from */
    void box.offsetHeight;

    box.addEventListener('transitionend', finish);
    var timer = window.setTimeout(finish, speed(details) + 120);

    box.style.height = to;
  }

  function open(details) {
    var box = content(details);
    if (!box || details.dataset.mpBusy === '1') return;

    if (singleOpen(details)) {
      var scope = details.closest('.product__info-container') || document;
      scope.querySelectorAll('.mp-accordion details[open]').forEach(function (other) {
        if (other !== details) close(other);
      });
    }

    var card = details.closest('.mp-accordion');
    details.open = true;
    details.querySelector('summary').classList.add('is-open');
    card.classList.remove('is-closing');

    if (reduced.matches) return;

    details.dataset.mpBusy = '1';
    animate(details, box, '0px', naturalHeight(box) + 'px', function () {
      box.style.height = '';
      box.classList.remove('mp-animating');
      delete details.dataset.mpBusy;
    });
  }

  function close(details) {
    var box = content(details);
    if (!box || details.dataset.mpBusy === '1') return;

    var summary = details.querySelector('summary');
    var card = details.closest('.mp-accordion');
    summary.classList.remove('is-open');

    if (reduced.matches) {
      details.open = false;
      return;
    }

    details.dataset.mpBusy = '1';
    card.classList.add('is-closing');

    animate(details, box, naturalHeight(box) + 'px', '0px', function () {
      /* hide first, then drop the inline height — one paint, no flash of the
         full-height content between the two */
      details.open = false;
      box.style.height = '';
      box.classList.remove('mp-animating');
      card.classList.remove('is-closing');
      delete details.dataset.mpBusy;
    });
  }

  function onClick(event) {
    var summary = event.target.closest('.mp-accordion summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!content(details)) return;

    event.preventDefault();
    if (details.open) {
      close(details);
    } else {
      open(details);
    }
  }

  function init() {
    document.addEventListener('click', onClick);

    document.querySelectorAll('.mp-accordion details[open] > summary').forEach(function (summary) {
      summary.classList.add('is-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
